/**
 * Zod's global setup. `index.tsx` imports this module FIRST, because zod reads
 * the setting while each schema is built — at module load — not when it parses.
 *
 * Zod 4 compiles object parsers with the `Function` constructor when the page
 * allows it, and finds out by probing `Function('')`. Production serves a CSP
 * without 'unsafe-eval' (see grazia-infra's Caddy site), so the probe is
 * refused: zod catches that and falls back, but the browser still logs a CSP
 * violation on every load, which buries real ones. `jitless` skips the probe;
 * the interpreted parser it selects is the one that ran under that CSP anyway.
 */
import { z } from 'zod';

z.config({ jitless: true });
